import { ApolloClient, InMemoryCache } from "@apollo/client";

const client = () => {
  return new ApolloClient({
    uri: window.configuration.GRAPH_GATEWAY_URL,
    cache: new InMemoryCache(),
  });
};

export default client;
